import React from 'react'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { MOBILE_WIDTH } from '../utils'

/**
 * @param {Object} props - The props
 * @param {number} props.viewportWidth - The viewport width
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3CourseModulePlaceholder
 */

const DetailPageV3CourseModulePlaceholder = (props) => {
  const {
    viewportWidth,
    staticText,
  } = props

  const isMobile = viewportWidth < MOBILE_WIDTH

  const className = [
    'detail-page-v3__course-module-item-placeholder',
    isMobile ? 'detail-page-v3__course-module-item--mobile' : null,
  ].filter((cls) => !!cls).join(' ')

  return (
    <div className={className}>
      <div className="detail-page-v3__course-module-item-placeholder-frame">
        <div className="detail-page-v3__course-module-item-placeholder-icon" />
        <div className="detail-page-v3__course-module-item-placeholder-text">
          {staticText.get('comingSoon')}
        </div>
      </div>
      <div className="detail-page-v3__course-module-item-placeholder-label">
        {staticText.get('comingSoon')}
      </div>
    </div>
  )
}

export default connectRedux((state) => ({
  viewportWidth: state.app.getIn(['viewport', 'width']),
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseModulePlaceholder)
